import React from 'react';

import type { IRibbonBtnConfig } from '../RibbonConfig';

import styles from './RibbonMenuExpandMoreButton.module.scss';
import { ExpandMore } from '@mui/icons-material';
import RibbonButtonSize from '../RibbonButtonSize';

const RibbonMenuExpandMoreButton = (props: IRibbonBtnConfig, ref) => {
    if (!props.config) {
        console.error(`Missing props.config: ${JSON.stringify(props)}`);
        return <></>;
    }

    const isLargeIcon: boolean =
        props.size === RibbonButtonSize.LargeIcon ||
        props.size === RibbonButtonSize.LargeIconWithText;
    const cssClasses: string[] = [styles.button];

    if (isLargeIcon) {
        cssClasses.push(styles.buttonL);
    }

    return (
        <button
            ref={ref}
            key={`rbnMenuExpandMoreBtn-${props.config.Key}`}
            className={cssClasses.join(' ')}
            disabled={!props.config.Enabled}
            onClick={props.config.Callback}
        >
            <ExpandMore />
        </button>
    );
};

export default React.forwardRef(RibbonMenuExpandMoreButton);
